import { render, staticRenderFns } from "./InstitutionTypeRule.vue?vue&type=template&id=7f509098"
import script from "./InstitutionTypeRule.vue?vue&type=script&lang=js"
export * from "./InstitutionTypeRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f509098')) {
      api.createRecord('7f509098', component.options)
    } else {
      api.reload('7f509098', component.options)
    }
    module.hot.accept("./InstitutionTypeRule.vue?vue&type=template&id=7f509098", function () {
      api.rerender('7f509098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/InstitutionTypeRule.vue"
export default component.exports